import React from 'react'
import PageLayout from '../pagelayout';
import Tabs from './tabs';
import { UpcomingOrders, CompletedOrders } from './order';
import OrdersMap from './ordersmap';

const tabs = [
    {
        name: "Ongoing orders",
        component: <UpcomingOrders />
    },
    {
        name: "Completed orders",
        component: <CompletedOrders />
    }
];

const OrderPage = () => {
    return (
        <PageLayout Map={OrdersMap}>
            <Tabs tabs={tabs} />
        </PageLayout>
    )
}

export default OrderPage
